import React, { useMemo } from 'react'
import {
  InstagramIcon,
  LinkedinIcon,
  SnapchatIcon,
  TiktokIcon,
  TwitterIcon,
  YoutubeIcon,
} from 'components'

const socialLinks = [
  {
    key: 'tiktokLink',
    title: 'Tiktok',
    Icon: TiktokIcon,
  },
  {
    key: 'instagramLink',
    title: 'Instagram',
    Icon: InstagramIcon,
  },
  {
    key: 'twitterLink',
    title: 'Twitter',
    Icon: TwitterIcon,
  },
  {
    key: 'snapchatLink',
    title: 'Snapchat',
    Icon: SnapchatIcon,
  },
  {
    key: 'youtubeLink',
    title: 'Youtube',
    Icon: YoutubeIcon,
  },
  {
    key: 'linkedinLink',
    title: 'Linkedin',
    Icon: LinkedinIcon,
  },
]

const SocialLinks = ({ user }) => {
  const links = useMemo(
    () =>
      socialLinks
        .map(link => ({
          ...link,
          value: user[link.key],
        }))
        .filter(({ value }) => value),
    [user]
  )

  if (!links.length) {
    return null
  }

  return (
    <ul className="mt-14 mb-8 flex flex-wrap items-center">
      {links.map(({ key, value, title, Icon }) => (
        <li key={key} className="list-none">
          <a
            href={value}
            title={title}
            target="_blank"
            rel="noreferrer"
            className="flex items-center justify-center w-11 h-11 bg-woodsmokeBlack rounded-full mr-2.5 hover:opacity-80 md:w-12 md:w-12"
          >
            <Icon className="text-white w-4" />
          </a>
        </li>
      ))}
    </ul>
  )
}

export default SocialLinks
